'use es6';

export const getRelevantQuote = (activeQuotes, allowedSkuIds) => {
  if (activeQuotes.size < 1) return null;
  const relevantQuotes = activeQuotes.filter(quote => {
    const recurringCharges = quote.recurringCharges || [];
    const nonRecurringCharges = quote.nonRecurringCharges || [];
    const relevantRecurringCharge = recurringCharges.find(charge => allowedSkuIds.includes(charge.skuId));
    const relevantNonRecurringCharge = nonRecurringCharges.find(charge => allowedSkuIds.includes(charge.skuId));
    return relevantRecurringCharge || relevantNonRecurringCharge;
  }).sort((quoteA, quoteB) => quoteA.id - quoteB.id);
  if (!relevantQuotes.length) return null;
  return relevantQuotes[relevantQuotes.length - 1];
};